











































































import { isValidUsername } from "@/utils/validate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { Route } from "vue-router";
import { ElForm } from "element-ui/types/form";
import { getRememberMe, getLanguage } from "../../utils/auth";
import path from "path";
import { ResCode } from "@/api/baseDefine";
import i18n from "@/lang";

@Component
export default class Login extends Vue {
  private rememberMe = false;
  private languages: string[] = [];
  private languageIDs: string[] = [];
  private loginForm = {
    email: "",
    password: "",
    rememberMe: "",
    languageID: "",
    language: ""
  };
  private loginRules = {
    email: [{ required: true, trigger: "blur", validator: this.validateEmail }],
    password: [
      { required: true, trigger: "blur", validator: this.validatePass }
    ]
  };
  private loading = false;
  private pwdType = "password";
  private redirect: string | undefined = undefined;
  private validateEmail(rule: any, value: string, callback: any) {
    if (value.length < 1) {
      callback(new Error(this.$t("validate.email").toString()));
    } else {
      callback();
    }
  }
  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 5) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }

  @Watch("$route", { immediate: true })
  private OnRouteChange(route: Route) {
    // TODO: remove the "as string" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    this.redirect = route.query && (route.query.redirect as string);
  }

  private showPwd() {
    if (this.pwdType === "password") {
      this.pwdType = "";
    } else {
      this.pwdType = "password";
    }
  }

  private handleLogin() {
    let rememberMe = this.rememberMe;
    (this.$refs.loginForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.loginForm.languageID = this.languageIDs[
          this.languages.indexOf(this.loginForm.language)
        ];
        i18n.locale = this.loginForm.languageID;
        this.loginForm.rememberMe = rememberMe ? "1" : "0";
        UserModule.Login(this.loginForm)
          .then((ok: boolean) => {
            if (ok) {
              this.loading = false;
              this.$router.push({ path: this.redirect || "/" });
            } else {
              this.loading = false;
              console.error("logfail");
            }
          })
          .catch(error => {
            console.error(error);
            this.loading = false;
          });
      } else {
        return false;
      }
    });
  }

  private created() {
    let rememberMe = getRememberMe();
    let languageID = getLanguage();
    this.rememberMe = rememberMe === "1";
    this.languages = [
      this.$t("language.CN").toString(),
      this.$t("language.JAP").toString(),
      this.$t("language.English").toString()
    ];
    this.languageIDs = ["CN", "JAP", "EN"];
    if (!languageID) {
      languageID = this.languageIDs[0];
    }
    this.loginForm.language = this.languages[
      this.languageIDs.indexOf(languageID)
    ];
  }
}
